import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-204e493a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "layout-container" };
import AppMain from "./components/AppMain.vue";
import Siderbar from "./components/Sidebar/index.vue";
import Navbar from "./components/Navbar.vue";
import { useRoute } from "vue-router";
import { publicRoutes } from "@/router";
import { computed } from "vue";
import { getChildrenNames } from "@/utils/index";
import { getRoles } from "@/utils/auth";
import { appCounterStore } from "@/store/app";
import { isMobileDevice } from "@/utils/index";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    setup(__props) {
        const appStore = appCounterStore();
        const sidebar = computed(() => appStore.sidebar);
        const route = useRoute();
        const isShow = computed(() => {
            if (["personal-index"].includes(route.name) && isMobileDevice())
                return false;
            if (route.meta.h5)
                return false;
            return route.name !== "application-add";
        });
        const showSidebar = computed(() => {
            if (["personal-index"].includes(route.name) && isMobileDevice())
                return false;
            if (route.meta.h5)
                return false;
            return true;
            if (getRoles()[0] === "admin")
                return true;
            return ![...getChildrenNames(publicRoutes), "application-add"].includes(route.name);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createVNode(Siderbar, null, null, 512), [
                    [_vShow, _unref(showSidebar)]
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["content-layout", {
                            'has-navbar': !_unref(isShow),
                            expand: _unref(sidebar),
                            mobile: !_unref(isShow),
                            'has-min-width': _unref(showSidebar)
                        }])
                }, [
                    _withDirectives(_createVNode(Navbar, null, null, 512), [
                        [_vShow, _unref(isShow)]
                    ]),
                    _renderSlot(_ctx.$slots, "main", {}, () => [
                        _createVNode(AppMain)
                    ])
                ], 2)
            ]));
        };
    }
});
